<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:25:51
 * @FilePath: \mrc-ess-fronted\src\App.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:13:29
-->
<template>
  <v-app id="app" class="app-main">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  computed: {},
  data() {
    return {
      loading: true,
    };
  },
  watch: {},
  created() {
    document.getElementById("loading").style.display = "none";
  },
  mounted() {
    document.getElementById("body").style.height = "auto";
    /**
     * @description: 限制多个标签页，只能登录同一用户
     * @param {*}
     * @return {*}
     * @toDo:
     */
    window.addEventListener("storage", (e) => {
      if (e && e.key === "mrc-ess-base-application-user-token") {
        if (e.oldValue !== e.newValue) this.$toPage("/login", {}, "replace");
      }
    });
    // 限制多个标签页，只能登录同一用户
  },
};
</script>
<style>
@import "./assets/animate/animate.css"; /* 导入动画 */
@import "./assets/common/common.css"; /* 导入公共样式 */
@import "./assets/common/delay.css"; /* 导入公共样式 */
@import "./assets/common/default.css"; /* 导入公共样式 */
</style>
<style lang="scss">
</style>